import { TGender } from "../ModuleStep/components/ModuleBottomSheet/types";

export type TOptionGender = { name: string; value: TGender };

export const genderOptions: TOptionGender[] = [
  { name: "Todos", value: "OTHER" },
  { name: "Feminino", value: "FEMALE" },
  { name: "Masculino", value: "MALE" },
];
